/* eslint camelcase: 0 */

import axios from 'axios';

if (process.env.NODE_ENV == 'production') {
    axios.defaults.baseURL = 'https://api.secure.lenses.io';
}
const tokenConfig = (token) => ({
    headers: {
        'Authorization': `Bearer ${token}`, // eslint-disable-line quote-props
    },
});

export function authenticate(username, password) {
    return axios.post('/api/auth', {
        username,
        password,
    });
}

export function me(token) {
    return axios.get('/api/users/me', tokenConfig(token));
}

export function fetchUsers(token) {
    return axios.get('/api/users', tokenConfig(token))
}

export function createNewUser(user, token) {
    return axios.post('/api/users', {user}, tokenConfig(token));
}

export function patchUser(id, user, token) {
    return axios.patch(`/api/users/${id}`, {user}, tokenConfig(token));
}

export function patchPassword(id, oldPass, newPass, token) {
    return axios.patch(`/api/users/${id}/password`, {
        old_password: oldPass,
        password: newPass,
    }, tokenConfig(token));
}

export function getUser(id, token) {
    return axios.get(`/api/users/${id}`, tokenConfig(token));
}

export function removeUser(id, token) {
    return axios.delete(`/api/users/${id}`, tokenConfig(token));
}

export function getUserFiles(id, token) {
    return axios.get(`/api/users/${id}/files`, tokenConfig(token));
}

export function uploadFile(id, file, token) {
    let formData = new FormData()
    formData.append('lenses_file', file)
    formData.append('lenses_filename', file.name)

    let config = tokenConfig(token);
    config.headers['Content-Type'] = 'multipart/form-data';
    
    return axios.post(`/api/users/${id}/files`, formData, config)
}

export function signFileUri(id, token) {
    return axios.post(`/api/files/${id}/sign`, {}, tokenConfig(token));
}

export function removeFile(id, token) {
    return axios.delete(`/api/files/${id}`, tokenConfig(token));
}


// WEBPACK FOOTER //
// ./src/utils/http_functions.js